import {Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions} from '@material-ui/core'
import * as classnames from 'classnames';
import {StringResources} from '../localization/StringResources';
import {Strings} from '../localization';
import images from '../images';
import Stripe from '../services/stripe/stripe';
import {FieldValidatedValue, FormValidator} from '../utils/validation/FormValidator';
import {Masker} from '../utils/masker/Masker';
import {LoadingSpinner} from './LoadingSpinner';
import Countries from '../types/enums/Counties';
import Currencies from '../types/enums/Currencies';
import {Api} from '../services/api/api';
import {StoreState} from '../reducers';
import {connect} from 'react-redux';
import {ClientInfo} from '../types';
import * as React from 'react'
import {Actions} from '../actions/signIn';

interface OwnProps {
    isDialogOpen: boolean,
    onClose: (success:boolean) => void,
}
interface StateProps {

    clientInfo?: ClientInfo
}
interface DispatchProps{
    onUpdateStripeAccount: (acc:string)=>void
}
type Props = OwnProps & StateProps & DispatchProps;

interface OwnState {
    formPaymentInfo: FormPaymentInfoType,
    fieldsPaymentInfoError: boolean,
    errorText?: string
    serverError: boolean
    error: boolean,
    inProcess:boolean
}
enum FormPaymentInfoFields {
    CardNumber = 'cardNumberInput',
    CardExpirationDate = 'cardExpirationDateInput',
    CardCvv = 'cardCvvInput'
}
interface FormPaymentInfoType {
    [FormPaymentInfoFields.CardNumber]: FieldValidatedValue
    [FormPaymentInfoFields.CardExpirationDate]: FieldValidatedValue
    [FormPaymentInfoFields.CardCvv]: FieldValidatedValue
}

class PaymentInfoRequiredDialogComponent extends React.Component<Props, OwnState> {
    private formPaymentInfoValidator: FormValidator<FormPaymentInfoType>;
    private _stripe: Stripe

    constructor(props: any) {
        super(props)
        this.formPaymentInfoValidator = this.initPaymentInfoForm()
        this.state = {
            formPaymentInfo: this.formPaymentInfoValidator.values(),
            fieldsPaymentInfoError: false,
            serverError: false,
            error: false,
            inProcess:false
        }
    }
    componentDidMount(): void {
        Stripe.getStripe()
            .then(stripe => {
                this._stripe = stripe
                console.log(stripe)
            })
            .catch(error => {
                console.log('resolving stripe obj error')
                console.log(error)
            })
    }

    onPaymentInfoChange = (e: (React.ChangeEvent<HTMLInputElement> & React.ChangeEvent<HTMLSelectElement>) | (React.FocusEvent<HTMLInputElement>)) => {
        let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
        this.updatePaymentInfoValueWithValidation(e.target.name, value)
    }
    updatePaymentInfoValueWithValidation = (name: string, value: any) => {
        return new Promise(resolve => {
            this.formPaymentInfoValidator.setState([{
                name: name,
                value: value
            }])
            this.setState({
                formPaymentInfo: this.formPaymentInfoValidator.values(),
                fieldsPaymentInfoError: !this.formPaymentInfoValidator.isValid(),
                errorText: this.formPaymentInfoValidator.getError(),
                serverError: false,
                error: false
            }, () => { resolve() })
        })
    }
    private initPaymentInfoForm = () => {
        let formValidator = new FormValidator<FormPaymentInfoType>([
            {
                name: FormPaymentInfoFields.CardNumber,
                value: '',
                validator: (value: any) => {
                    console.log('validator',value);
                    return ((!this._stripe || !this._stripe.validateCardNumber(value))) ?
                        'cardNumber' :
                        undefined
                },
                messages: {
                    cardNumber: StringResources.getString(Strings.Preferences.CardInfo.Errors.CardNumber)
                },
                masker: new Masker(Masker.cardNumber, Masker.placeSymbol),
                passMaskedToValidation: true
            },
            {
                name: FormPaymentInfoFields.CardExpirationDate,
                value: '',
                validator: (value: any) => {
                    return ((!this._stripe || !this._stripe.validateExpireDateStr(value))) ?
                        'expire' :
                        undefined
                },
                messages: {
                    expire: StringResources.getString(Strings.Preferences.CardInfo.Errors.ExpirationDate)
                },
                masker: new Masker(Masker.expireDateMask, Masker.placeSymbol),
                passMaskedToValidation: true
            },
            {
                name: FormPaymentInfoFields.CardCvv,
                value: '',
                validator: (value: any) => {
                    return ((!this._stripe || !this._stripe.validateCvc(value))) ?
                        'cvv' :
                        undefined
                },
                messages: {
                    cvv: StringResources.getString(Strings.Preferences.CardInfo.Errors.CVV)
                }
            }
        ])
        return formValidator
    }
    handleCancelClick = ()=>{
        this.props.onClose(false);
    }
    handleSaveDetailsClick = async () => {
        await this.validatePaymentInfoFields()
        if (this.state.fieldsPaymentInfoError) {
            return
        }

        this.setState({ inProcess: true })

        try {
            let stripeToken = await this._stripe.createToken({
                cardNumber: (this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].value),
                name: this.getFullName,
                cvc: this.state.formPaymentInfo[FormPaymentInfoFields.CardCvv].value as number,
                expireMonth: this.CardExpMonth,
                expireYear: this.CardExpYear,
                country: Countries.US,
                currency: Currencies.USD
            })
            console.log('stripe token creation success', stripeToken)
            let sendTokenResponse = await Api.sendStripeTokenAuthorized(stripeToken.id)
            console.log(sendTokenResponse);
            this.props.onUpdateStripeAccount(stripeToken.id)
            this.setState({ inProcess: false })
            this.props.onClose(true)
        } catch (error) {
            console.log('card info updating error', error)
            this.setState({ serverError: true })
            this.setState({ inProcess: false })
        }
    }
    get getFullName() {
        return !!this.props.clientInfo ? `${this.props.clientInfo.firstName} ${this.props.clientInfo.lastName}` : '';
    }
    get CardExpMonth() {
        // tslint:disable-next-line:radix
        return parseInt((this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].value as string).substr(0, 2))
    }

    get CardExpYear() {
        // tslint:disable-next-line:radix
        return parseInt((this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].value as string).substr(2))
    }
    validatePaymentInfoFields = () => {
        return new Promise((resolve) => {
            this.formPaymentInfoValidator.validate()
            this.setState({
                formPaymentInfo: this.formPaymentInfoValidator.values(),
                fieldsPaymentInfoError: !this.formPaymentInfoValidator.isValid(),
                errorText: this.formPaymentInfoValidator.getError(),
                serverError: false,
                error: false
            }, () => { resolve() })
        })
    }
    render() {
        return (
            <Dialog open={this.props.isDialogOpen}>
                <DialogTitle>Payment info required</DialogTitle>
                <DialogContent>
                    <LoadingSpinner show={this.state.inProcess} />
                    <div className="new-account">
                        <form className="required-payment-info-form">
                            <div className="info-text">
                                You must enter your credit card information prior to posting your job.<br />
                                A charge is only made if you accept a bid.
                            </div>
                            <input
                                className={classnames('card-number', { error: this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].error })}
                                type="text"
                                name={FormPaymentInfoFields.CardNumber}
                                placeholder={StringResources.getString(Strings.Preferences.CardInfo.Inputs.CardNumber.placeholder)}
                                value={this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].masked ?
                                    this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].masked : ''}
                                onChange={this.onPaymentInfoChange}
                                maxLength={19}
                            />
                            <input
                                className={classnames('expiration-date half-sized', { error: this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].error })}
                                type="text"
                                name={FormPaymentInfoFields.CardExpirationDate}
                                value={this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].masked ?
                                    this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].masked : ''}
                                onChange={this.onPaymentInfoChange}
                                placeholder={StringResources.getString(Strings.Preferences.CardInfo.Inputs.CardExpirationDate.placeholder)}
                                maxLength={5}
                            />
                            <input
                                name={FormPaymentInfoFields.CardCvv}
                                className={classnames('cvv', { error: this.state.formPaymentInfo[FormPaymentInfoFields.CardCvv].error })}
                                type="text"
                                placeholder={StringResources.getString(Strings.Preferences.CardInfo.Inputs.CardCVV.placeholder)}
                                value={this.state.formPaymentInfo[FormPaymentInfoFields.CardCvv].value}
                                onChange={this.onPaymentInfoChange}
                                required={true}
                                maxLength={4}
                            />
                            <div style={{textAlign:'center'}}>
                                <img src={images.securePaymentShrinked} alt="" />
                            </div>
                        </form>
                    </div>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <Button onClick={this.handleCancelClick}>Cancel</Button>
                    <Button onClick={this.handleSaveDetailsClick} color={'primary'}>Save card details</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

function mapStateToProps(state: StoreState): StateProps {
    return {
        clientInfo: state.auth.user
    }
}
function mapDispatchToProps(dispatch: any): DispatchProps {
    return {
        onUpdateStripeAccount: (acc:string) => dispatch(Actions.updateStripeAccount(acc))
    }
}

export const PaymentInfoRequiredDialog = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(PaymentInfoRequiredDialogComponent);



// WEBPACK FOOTER //
// ./src/components/PaymentInfoRequiredDialog.tsx